const ListLoading = () => (
  <div className='text-center my-4'>
    <span className='spinner-border spinner-border-sm align-middle ms-2' />
  </div>
)

export {ListLoading}
